//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ConfirmButton from '@/components/confirmButton';

export default {
  name: 'WorkflowConfigActionList',
  components: { ConfirmButton },
  props: {
    actionList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      // 弹框
      popoverVisible: false,
    };
  },
  methods: {
    deleteAction({ id }) {
      this.popoverVisible = false;
      this.$emit('delete-item', id);
    },
  },
};
